<!-- <app-lbn-container title="Billing" subTitle="Manage invoices and payments">
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <lbn-input-field formControlName="email" label="Email" type="email" placeholder="you@example.com"></lbn-input-field>
    <lbn-input-field formControlName="password" label="Password" type="password" placeholder="Password"></lbn-input-field>

    <div style="margin-top:16px">
      <button mat-raised-button color="primary" type="submit">Submit</button>
    </div>
  </form>
<app-lbn-container> -->

  <div style="text-align:center; margin-top: 40px;">
  <h1>Welcome to Client Management!</h1>
  <p>New app for applet🎉</p>
</div>
<p>monthly works!</p>
